/** Sello de build visible para staff — confirma qué versión está desplegada. */
export default function BuildStamp({ className = '' }) {
  const build = import.meta.env.VITE_APP_BUILD || 'dev';
  return (
    <p
      className={`text-[10px] text-stone-400 font-mono select-all ${className}`.trim()}
      title="Versión desplegada (commit). Si no coincide con el último push a main, el deploy no se aplicó."
    >
      build {build}
    </p>
  );
}
